import { render, staticRenderFns } from "./all-projects.vue?vue&type=template&id=56b03289&"
import script from "./all-projects.vue?vue&type=script&lang=js&"
export * from "./all-projects.vue?vue&type=script&lang=js&"
import style0 from "./all-projects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports